<template>
    <v-dialog v-model="dialog" persistent width="400">
        <v-card>
            <v-toolbar class="text-h5 white--text" color="primary">
                <v-icon class="mr-2" color="white">create_new_folder</v-icon>
                Creazione Cartella
            </v-toolbar>
            <v-card-text class="my-5">
                <v-row class="align-center mb-0">
                    <v-text-field label="Inserisci nome cartella" hide-details v-model="nomeCartella" autofocus />
                </v-row>

                <v-row class="align-center mt-0">
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-checkbox :disabled="checkboxUnder" v-model="checkboxNew" hide-details
                            label="Nuova cartella" />
                    </v-col>
                    <v-col cols="12" class="ma-0 pa-0">
                        <v-checkbox :disabled="checkboxNew || listaDirectories.length <= 0" v-model="checkboxUnder"
                            hide-details label="Sotto cartella" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="chiudiDialog()">
                    ANNULLA
                </v-btn>
                <v-btn color="primary" text @click="creaCartella(nomeCartella)">
                    CONFERMA
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { crea_cartella } from "@/api/api.archivio.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        pathCartella: { type: String, default: "" },
        listaDirectories: { type: Array, default: null },
    },

    data: () => ({
        nomeCartella: "",
        checkboxNew: false,
        checkboxUnder: false,
    }),

    methods: {
        chiudiDialog(value) {
            this.$emit("chiudiDialog", value);
            this.resetCampi();
        },

        resetCampi() {
            this.checkboxNew = false;
            this.checkboxUnder = false;
            this.nomeCartella = "";
        },

        async creaCartella(nome) {
            let par = "";
            if (nome != "" && nome != null && (this.checkboxNew == true || this.checkboxUnder == true)) {
                let data = {
                    nome: nome,
                    path: ""
                }
                //setto path cartella
                if (this.checkboxNew == true) {
                    let pathOrdine = this.pathCartella.split("/");
                    data.path = pathOrdine[0] + "/" + pathOrdine[1] + "/" + pathOrdine[2] + "/" + pathOrdine[3] + "/" + pathOrdine[4] + "/" + nome;
                }
                if (this.checkboxUnder == true) data.path = this.pathCartella + "/" + nome;

                par = "?path=" + encodeURIComponent(data.path);
                let res = await crea_cartella(data, par);

                if (res.data == "OK") {
                    if (this.checkboxNew == true) this.chiudiDialog(0);
                    if (this.checkboxUnder == true) this.chiudiDialog(1);
                }
                else this.$toast.alert(res.data + " " + this.nomeCartella);
            }
        },
    },
};
</script>